import React  from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import MenuList from "./components/CustomerMenu";
import './App.css';
import AdminLogin from "./pages/AdminLogin";
import Category from "./pages/Category"; 
import Foods from "./pages/FoodsProfile"; 
import AddonsManagement from './pages/AddonsManagement';
import OrderReceipt from "./pages/OrderReceipt";
import PrintableQRCodeCanvas from "./pages/WebQRCode";
import KitchenDisplay from './components/KitchenDisplay';
import OrderStatusPage from "./components/OrderStatusPage";
import FoodOrderPage from "./pages/CustomerMenu";
import MobileOrderPage from './components/MobileOrderPage';
import StallAuth from './components/StallAuth';
import ImageUpload from './pages/ImageUpload';

const ProtectedMobileOrder = () => {
  const stallID = localStorage.getItem('stallID');
  const username = localStorage.getItem('username');
   //alert("starting");
  if (stallID && username) {
    return <MobileOrderPage />;
  } else {
    return <Navigate to="/StallAuth" />;
  }
};

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Router>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/AdminLogin" element={<AdminLogin />}  /> 
            <Route path="/category" element={<Category />} />
            <Route path="/foods" element={<Foods />} />
            <Route path="/ordering" element={<MenuList/>} />  
            <Route path="/addons-management" element={<AddonsManagement />} />
            <Route path="/order-receipt/:orderId" element={<OrderReceipt />} />
            <Route path="/PrintableQRCodeCanvas" element={<PrintableQRCodeCanvas />} />  
            <Route path="/KitchenDisplay" element={<KitchenDisplay />} />
            <Route path="/OrderStatusPage" element={<OrderStatusPage />} />
            <Route path="/FoodOrderPage" element={<FoodOrderPage />} />
             <Route path="/ImageUpload" element={<ImageUpload />} /> 
            
            {/* Protected Mobile Order Page - Requires Login */}
            <Route path="/mobile-order-page" element={<MobileOrderPage />} />  
            <Route path="/MobileOrderPage" element={<ProtectedMobileOrder />} />
           
            {/* Stall Authentication */}
            <Route path="/StallAuth" element={<StallAuth />} />
          </Routes>
        </Router>
      </header>
    </div>   
  );
}

export default App;